import { Injectable } from '@angular/core';
import * as SagaBase from '@models/imported/SagaBase';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { UnitActivityResource } from '@models/imported/SagaSchema/UnitActivityResource';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { CacheService } from '@services/cache/cache.service';
import { CacheAction } from '@services/cache/cacheEvent';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { IModelService, IObjectChange, ModelService } from '@services/model-factory';

@ModelService(UnitActivity)
@Injectable()
export class UnitActivityModelService implements IModelService<UnitActivity> {
  constructor(private fetchList: FetchListService, private cache: CacheService) {}

  change(change: IObjectChange<UnitActivity>) {
    const object = change.target;
    // Set the unit's status
    const row = this.fetchList.getRow(ListResourceStatus, object.Status);
    if (row !== object.status) {
      object.status = row;
    }

    // Set its parent object
    object.callcard = this.cache.getObjectByUid(object.CallCardID);

    // update unit resources
    if (change.action !== CacheAction.removed) {
      object.vehicles.length = 0;
      object.component<UnitActivityResource>(UnitActivityResource).forEach(activityRes => {
        const res = this.cache.getObjectByUid(activityRes.ResourceUId);
        if (res !== null) {
          switch (activityRes.ResType) {
            case SagaBase.ResourceType.Vehicle:
              object.vehicles.push(res);
              break;
          }
        }
      });
    }

    object.changed(null);
  }
}
